import { L1StatusBarBackground, L2Interface, L2InterfaceMode, V2L3DashboardSyncBanner, V2L4DashboardRoot, V2L5AppIntro, V2L3DashboardListsContainer } from "@fusion-advantage/formrender"
import { LxDashboardAppHeader } from "./LxDashboardAppHeader"
import { useAppDispatch, useAppSelector } from '../../../redux/hooks'
import { selectDashboardDisplayIdentity } from "../../../redux/dashboardDataSlice"
import { LxDashboardDetail } from "./LxDashboardDetail"
import { LxTodoList } from "./LxTodoList"
import { LxApptList } from "./LxApptList"
import { selectSessionIsExpired } from "../../../redux/selectSession"
import { LxAppIntro } from "./LxAppIntro"
import { AppModal, pushAppModal } from "../../../redux/appSlice"

export const LxDashboard = () => {
	const dispatch = useAppDispatch()
	const loading = useAppSelector(state => Boolean(state.app.ldng.login))
	const displayIdentity = useAppSelector(selectDashboardDisplayIdentity)
	const pendingDeviceToCloudCount = useAppSelector(state => state.dashboardData.pendingDeviceToCloudCount)
	// by virtue of the above sync selector refreshing this component,
	// this value will be recalculated after every background sync
	// so it should be fairly responsive to when the session actually expires
	const sessionIsExpired = useAppSelector(selectSessionIsExpired)
	if(!displayIdentity || loading || sessionIsExpired) {
		return (
			<LxAppIntro />
		)
	}
	return (
		<L2Interface
			mode={L2InterfaceMode.FixedHeight}
			statusBar={<L1StatusBarBackground />}
			header={<LxDashboardAppHeader displayIdentity={displayIdentity} />}
		>
			{pendingDeviceToCloudCount > 0 ? (
				<div style={{padding: '1rem 2rem 0'}}>
					<V2L3DashboardSyncBanner
						count={pendingDeviceToCloudCount}
						onClick={() => dispatch(pushAppModal(AppModal.Sync))}
					/>
				</div>
			) : null}
			<V2L4DashboardRoot>
				<V2L3DashboardListsContainer>
					<LxTodoList />
					<LxApptList />
				</V2L3DashboardListsContainer>
				<LxDashboardDetail />
			</V2L4DashboardRoot>
		</L2Interface>
	)
}
